// Paleta categórica validada (orden fijo, 8 tonos, Delta E >= 8 CVD
// adyacente / >= 15 visión normal — ver skill de dataviz). El color sigue a
// la identidad del transportista, nunca a su posición/ranking, para que un
// mismo transportista se vea igual en cualquier cuenta o periodo.
const CATEGORICAL = {
  blue: '#2a78d6',
  orange: '#eb6834',
  aqua: '#1baf7a',
  yellow: '#eda100',
  magenta: '#e87ba4',
  green: '#008300',
  violet: '#4a3aa7',
  red: '#e34948'
}

// Lista confirmada contra selected_service.carrier real en producción
// (distinct() 2026-10-10): DHL, ESTAFETA, FEDEX, PAQUETEXPRESS, REDPACK,
// AMPM, J&TEXPRESS, BIGSMART — las 8 que realmente han aparecido.
export const CARRIER_COLORS = {
  DHL: CATEGORICAL.blue,
  ESTAFETA: CATEGORICAL.orange,
  PAQUETEXPRESS: CATEGORICAL.aqua,
  FEDEX: CATEGORICAL.yellow,
  REDPACK: CATEGORICAL.magenta,
  AMPM: CATEGORICAL.green,
  'J&TEXPRESS': CATEGORICAL.violet,
  BIGSMART: CATEGORICAL.red
}

// Para "Otros" (agregado del backend) o cualquier transportista fuera del
// mapa de arriba: un gris neutro, nunca uno de los 8 tonos de identidad.
export const OTHER_COLOR = '#54697D'

export function colorForCarrier (label) {
  return CARRIER_COLORS[label] || OTHER_COLOR
}



// WEBPACK FOOTER //
// ./src/commons/chartColors.js